<template>
  <div
    class="flex-1_4 podcast-container podcast-container-accesibilidad"
    v-bind:href="url"
  >
    <div class="podcast-content a11y-ocultar-imagen-link">
      <picture class="picture picture-podcast imagen">
        <a class="link-podcast" target="_blank" v-bind:href="url">
          <img v-bind:src="'img/podcast/' + card_imagen" />
        </a>
      </picture>
      <a
        class="link-podcast titulo-accesibilidad"
        target="_blank"
        v-bind:href="url"
      >
        <p>
          <strong>{{ titulo }}</strong>
        </p>
      </a>
      <p class="descripcion">{{ descripcion }}</p>
    </div>
    <div class="podcast-bottom">
      <div class="leer-mas">
        <button
          class="boton-leer-mas"
          type="button"
          @click="$modal.show(identificador)"
        >
          Leer más
        </button>
      </div>
      <div class="casa-enlace a11y-ocultar-imagen-link">
        <p class="casa-texto">{{ casa }}</p>
        <a target="_blank" v-bind:href="url">
          <img
            alt=""
            class="enlace imagen"
            src="../assets/icons/enlace-icon.svg"
          />
        </a>
      </div>
    </div>

    <modal
      :adaptative="true"
      :height="700"
      :width="400"
      :shiftY="0.65"
      class="modal-contenido"
      v-bind:name="identificador"
    >
      <div class="cerrar-modal" @click="$modal.hide(identificador)">X</div>
      <picture class="picture picture-podcast">
        <img v-bind:src="'img/podcast/' + card_imagen" />
      </picture>
      <p class="p-modal">
        <strong>{{ titulo }}</strong>
      </p>
      <p class="p-modal">{{ descripcion }}</p>
      <p class="p-modal">{{ autor }}</p>
      <p class="p-modal">{{ fecha }}</p>
      <div class="casa-enlace-modal">
        <p class="casa-texto-modal">{{ casa }}</p>
        <a class="casa-icono-modal" target="_blank" v-bind:href="url">
          <img alt="" class="enlace" src="../assets/icons/enlace-icon.svg" />
        </a>
      </div>
    </modal>
  </div>
</template>

<script>
export default {
  name: "Podcast",
  props: {
    titulo: {
      type: String,
      default: "Título del Podcast",
    },
    descripcion: {
      type: String,
      default: "Descripción del Podcsast",
    },
    url: {
      type: String,
      default: "blank",
    },
    casa: {
      type: String,
      default: "Sin información",
    },
    card_imagen: {
      type: String,
      default: "card_default.jpg",
    },
    autor: {
      type: String,
      default: "Sin información",
    },
    fecha: {
      type: String,
      default: "Sin información",
    },
    identificador: {
      type: String,
    },
  },
};
</script>

<style lang="scss">
.podcast-container{
  p {
    padding: 0 8px;
  }
  .modal-contenido {
  border-radius: 10px;
  overflow: hidden;
  font-size: 15px;

  .cerrar-modal {
    position: absolute;
    top: $gap * 0.5;
    right: $gap * 0.5;
    font-size: 22px;
    font-weight: bold;
    text-align: center;
    line-height: 40px;
    color: white;
    width: 40px;
    height: 40px;
    overflow: hidden;

    &:hover {
      cursor: pointer;
    }
  }
}
}

.p-modal {
  padding: 0 $gap;
}

img {
  max-width: 100%;
}

.link-podcast {
  color: #141414;

  &:hover {
    cursor: pointer;
    color: #141414;
  }
}

.casa-texto {
  font-weight: 500;
}

.enlace {
  &:hover {
    filter: invert(30%) sepia(54%) saturate(2135%) hue-rotate(315deg)
      brightness(89%) contrast(93%);
  }
}

.podcast-container {
  display: flex;
  flex-direction: column;
  margin-bottom: $gap;
  height: auto;
  border-radius: 10px;
  box-shadow: 2px 2px 10px #00000029;
  overflow: hidden;
  .picture-podcast {
    display: block;
    a {
      width: 100%;
    }
    img {
      width: 100%;
      border-radius: 10px 0 0 0;
    }
  }
  .podcast-content {
    flex: 2;
  }
  .podcast-bottom {
    flex-shrink: 0;
  }
  &:hover {
    box-shadow: 5px 5px 10px #00000029;
  }

  &:active {
    border: 1px solid #4589fc;
    box-shadow: 1px 1px 10px 1px #4589fc;
  }

  .casa-enlace {
    display: flex;
    justify-content: space-between;
    padding: 0 8px;
    bottom: 0;
    .casa-texto {
      min-width: 50%;
      padding: 0;
    }
  }
  .casa-enlace-modal {
    padding: 0 $gap;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .casa-texto-modal {
      padding: 0;
      font-weight: 600;
    }
  }

  .descripcion {
    max-height: 85px;
    overflow: hidden;
    @media (max-width: map-get($media-queries-limit, "mobile")) {
      max-height: 100%;
    }
  }

  .leer-mas {
    padding: 0 8px;
    bottom: calc(12% - #{$gap * 0.5});
    @media (max-width: map-get($media-queries-limit, "mobile")) {
      display: none;
    }

    .boton-leer-mas {
      border: 1px solid #141414;
      background: white;
      color: #141414;
      font-weight: 500;

      &:hover {
        box-shadow: 2px 2px 10px #00000029;
      }
    }
  }
}

@media (min-width: map-get($media-queries-limit, "mobile")) {
  .flex-1_4 {
    flex: 1 0 25%;
    max-width: calc(25% - #{$gap * 0.5});
    margin-bottom: $gap;
  }
}


</style>
